<template>
  <div class="kpi-card" :style="{ height: `${height}px` }">
    <div class="kpi-card__icon">
      <img :src="icon" :alt="title" width="40" height="42" />
    </div>
    <div class="kpi-card__title">
      {{ title }}
      <span v-if="statusDot" class="status-dot" :class="`status-dot--${statusDot}`"></span>
    </div>
    <div class="kpi-card__description">{{ $t(description) }}</div>
  </div>
</template>

<script>
export default {
  name: 'KpiBox',
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    statusDot: {
      type: String,
      default: null,
      validator: (value) => !value || ['red', 'orange'].includes(value),
    },
    height: {
      type: Number,
      default: 175,
    },
  },
};
</script>

<style scoped>
.kpi-card {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 24px 16px;
  border-radius: 4px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);
  border: solid 1px #e6eaee;
  background-color: #fff;
}

.kpi-card__title {
  font-size: 18px;
  font-weight: 600;
  color: #363647;
  margin: 10px 0;
}

.status-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  display: inline-block;
}

.status-dot--red {
  background-color: #ef4444;
}

.status-dot--orange {
  background-color: #f97316;
}

.kpi-card__description {
  font-size: 11px;
  font-weight: 600;
  color: #687692;
}
</style>
